import { z } from 'zod';
import { bulkCreateLocations } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  province: z.string().min(1, 'Province is required'),
  locationCode: z.string().optional().default(''),
  locationTypeKey: z.string().optional().default(''),
  isPublic: z.string().optional().default('false'),
  timezone: z.string().optional().default('UTC'),
  parentLocationSlug: z.string().optional().default(''),
});

export const locationConfig: CsvEntityConfig = {
  entityName: 'Locations',
  entityNameSingular: 'Location',
  columns: [
    { key: 'name', label: 'Name', required: true, description: 'Location name', exampleValue: 'Al-Noor Community' },
    { key: 'province', label: 'Province', required: true, description: 'Canadian province or territory enum', exampleValue: 'ONTARIO' },
    { key: 'locationCode', label: 'Location Code', required: false, description: 'Unique code (CC-PPP-XXXXX)', exampleValue: 'AE-DXB-00001' },
    { key: 'locationTypeKey', label: 'Location Type Key', required: false, description: 'Key of existing location type', exampleValue: 'apartment_building' },
    { key: 'isPublic', label: 'Is Public', required: false, description: 'true/false (default: false)', exampleValue: 'true' },
    { key: 'timezone', label: 'Timezone', required: false, description: 'IANA timezone (default: UTC)', exampleValue: 'Asia/Dubai' },
    { key: 'parentLocationSlug', label: 'Parent Location Slug', required: false, description: 'Slug of parent location', exampleValue: '' },
  ],
  validationSchema,
  exampleRows: [
    { name: 'Al-Noor Community', province: 'ONTARIO', locationCode: 'CA-ONT-00001', locationTypeKey: 'apartment_building', isPublic: 'true', timezone: 'America/Toronto', parentLocationSlug: '' },
  ],
  bulkCreateAction: bulkCreateLocations as any,
  importNotes: [
    'Required columns: name.',
    'Country is always set to Canada during import.',
    'Slug is auto-generated from the name if not provided.',
    'Location Type Key must match an existing location type.',
    'Parent Location Slug must reference an existing location.',
  ],
};



